import { createActionGroup, emptyProps } from '@ngrx/store';
import { BookingPackageType } from '@products/models/booking.model';

export const PackageStatusActions = createActionGroup({
  source: 'Package Status',
  events: {
    'Set initial package index status': (initialPackageIndex: number) => ({ initialPackageIndex }),
    'Set package index status': (bookingPackageTypes: BookingPackageType[]) => ({ bookingPackageTypes }),
    'Set is package loading status': (isPackageLoading: boolean) => ({ isPackageLoading }),
    'Reset reducer': emptyProps()
  }
});
